import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from 'vuex-shared-mutations'

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage
  }), createMutationsSharer({ predicate: ['login'] })],
  state: {
    user: '',
    token: '',
    isLogin: false,
    permissions: [],
    lang: process.env.VUE_APP_MULTILANG_LANG_DEFAULT,
    routeParam: [],
    AccessType: '',
    notify: ''
  },
  getters: {
    getUser: state => {
      return state.user
    },
    getPermissions: state => {
      return state.permissions
    },
    getRouteParam: state => {
      return state.routeParam
    },
    getAccessType: state => {
      return state.AccessType
    }
  },
  mutations: {
    login (state, user) {
      state.user = user
      state.token = JSON.parse(user).token
      state.isLogin = true
    },
    logout (state) {
      state.isLogin = false
      state.user = ''
      state.token = ''
      state.permissions = ''
      localStorage.removeItem('sToken')
      localStorage.removeItem('vuex')
      // window.localStorage.clear()
    },
    setPermission (state, permissions) {
      state.permissions = permissions
    },
    setLang (state, value) {
      state.lang = value
    },
    setRouteParam (state, rParam) {
      state.routeParam = rParam
    },
    setAccessType (state, value) {
      state.AccessType = value
    },
    setNotify (state, value) {
      state.notify = value
    }
  }
})
